import actions from './actions';
import mutations from './mutations';
import getters from './getters';

/** @type {import('./types').initialData} */
const state = {
  widgetData: {
    loading: false,
    errorMessage: '',
    successMessage: '',
  },
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
